import { useMemo, useState, useCallback, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
// import WaveSurfer from 'wavesurfer.js'
// import Regions from 'wavesurfer.js/dist/plugins/regions.esm.js'
// import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js';
import { useWavesurfer } from '@wavesurfer/react'
import Timeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
//import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline';
import serverURL from '../../config/serverConfig';
import { Share, Mail, MessageSquare, Copy, X, Volume2, Volume } from 'lucide-react';
import Slider from '@mui/material/Slider';


const Player = forwardRef((props, ref) => {

    const formatTime = (seconds) => [seconds / 60, seconds % 60].map((v) => `0${Math.floor(v)}`.slice(-2)).join(':')

    const containerRef = useRef(null)
    const [urlIndex, setUrlIndex] = useState(0)
    const [audioUrl, setAudioUrl] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    //console.log("Player render, track:", props.track)

    const getAudioUrl = async (key) => {
      const res = await fetch(`${serverURL}presigned-download?key=${encodeURIComponent(key)}`);
      const { url } = await res.json();
      console.log("Presigned URL fetched:", url);
      return url;
      // const text = await res.text();
      // console.log("RAW RESPONSE:", text);
    };


  
    useEffect(() => {
      async function load() {
        console.log(props.track)
        const url = await getAudioUrl(props.track.key);
        setAudioUrl(url);
        //console.log("Audio URL set:", url);
      }

      if (props.track?.key) {
        load();
      }
    }, [props.track]);

    const { wavesurfer, isPlaying, currentTime } = useWavesurfer({
      container: containerRef,
      height: 40,
      barWidth: 1,
      barHeight: 2,
      //url: '/audio/audio.mp3',
      url: audioUrl,
      plugins: useMemo(() => [Timeline.create()], []),
    //   plugins:  {
    //     plugin: Timeline,
    //     key: "timeline",
    //     options: {
    //        container: containerRef
    //     }
    //     },
      waveColor: "rgb(0, 0, 0)",
      progressColor: "rgb(70,70,70)",
      //progressColor: "rgb(255,238,0)",

      dragToSeek: true,
      cursorWidth: 4,
      mediaControls: false,
      interact: true,
    })

    const [volValue, setVolValue] = useState(100);
    const handleVolChange = (event, newValue) => {
      setVolValue(newValue);
    };
    
      const onPlayPause = useCallback(() => {
        wavesurfer && wavesurfer.playPause()
      }, [wavesurfer])


      useEffect(() => {
        wavesurfer && wavesurfer.playPause()
    }, [props.isPlaying])

    useEffect(() => {
        if (wavesurfer && props.stopCount > 0) {
            wavesurfer.stop()
        }
    }, [props.stopCount])

    useEffect(() => {
        if (wavesurfer && props.replayCount > 0) {
            wavesurfer.seekTo(0)
            wavesurfer.play()
        }
    }, [props.replayCount])

    useEffect(() => {
        if (wavesurfer && props.syncTime !== undefined) {
            wavesurfer.seekTo(props.syncTime / wavesurfer.getDuration())
        }
    }, [props.syncTime])

    useEffect(() => {
        if (wavesurfer && volValue !== undefined) {
            wavesurfer.setVolume(volValue/100)
        }
    }, [volValue])
     
/////////////////////////
if(props.selected==props.trackNum){
  wavesurfer && wavesurfer.setMuted(false)
} else {
  wavesurfer && wavesurfer.setMuted(true) 
 // console.log("mute")
}
useEffect(() => {
  //console.log(props.selected)
  if(props.selected==props.trackNum){
      wavesurfer && wavesurfer.setMuted(false)
      //getCurrentTime
  } else {
      wavesurfer && wavesurfer.setMuted(true)
      //console.log("mute")
      //setScrollTime
  }
}, [props.selected])
/////////////////////

useImperativeHandle(ref, () => ({
    getCurrentTime: () => wavesurfer ? wavesurfer.getCurrentTime() : 0,
}));



      //const wsRegions = wavesurfer.registerPlugin(RegionsPlugin.create())

    return(
    <>
      <div className="flex items-center w-full px-2">
        <div id="trackPlayer" className={props.selected==props.trackNum ? "activeTrack surfer w-full" : "notActiveTrack surfer w-full"}>
                <div className='trackTitleRow text-xs py-1'>
                    <span>{props.track.title}</span>
                    <span className='mr-2'>{new Date(props.track.upload_date).toLocaleDateString()}</span>
                </div>
                <div ref={containerRef} />
  
  
        <p className="text-xs pt-1 justify-self-center">{formatTime(currentTime)}</p>
      </div>
        <div id="volumeSlider"
          className={`flex flex-col gap-3 group relative flex items-center justify-center self-stretch px-2 my-2 rounded-r-lg bg-black transition-all duration-200 hover:bg-gray-900 cursor-pointer ${props.selected != props.trackNum ? 'bg-zinc-900' : ''}`}
        >
          <Volume2 />
          <Slider aria-label="Volume" orientation="vertical" size="small" valueLabelDisplay="auto" value={volValue} onChange={handleVolChange} /> 
          {/* sx={{ color: '#ffee00' }} */}
          <Volume />
        </div>
        <div
          onClick={() => setShowShareModal(true)}
          className={`group relative flex items-center justify-center self-stretch px-2 my-2 rounded-r-lg bg-black transition-all duration-200 hover:bg-gray-900 cursor-pointer ${props.selected != props.trackNum ? 'bg-zinc-900' : ''}`}
        >
          <Share className="w-4 h-4 text-blue-400 group-hover:text-blue-300 transition-colors duration-200" />
        </div>
      </div>

      {showShareModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
          onClick={() => setShowShareModal(false)}
        >
          <div
            className="gradientBG p-5 w-[280px] text-xs"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h5 className="uppercase font-semibold">Send Mix</h5>
              <div onClick={() => setShowShareModal(false)}>
                <X size={16} className="text-gray-400 hover:text-gray-200 cursor-pointer" />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <a
                href={`mailto:?subject=${encodeURIComponent(props.track.title)}&body=${encodeURIComponent(`${props.track.title}: ${audioUrl}`)}`}
                className="flex items-center gap-2 bg-gray-700 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded"
              >
                <Mail size={16} /> Email
              </a>
              <a
                href={`sms:?&body=${encodeURIComponent(`Here's ${props.track.title}: ${audioUrl}`)}`}
                className="flex items-center gap-2 bg-gray-700 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded"
              >
                <MessageSquare size={16} /> Text Message
              </a>
              <a
                onClick={() => {
                  navigator.clipboard.writeText(audioUrl);
                  setLinkCopied(true);
                  setTimeout(() => setLinkCopied(false), 2000);
                }}
                className="flex items-center gap-2 bg-gray-700 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded cursor-pointer"
              >
                <Copy size={16} /> {linkCopied ? "Copied!" : "Copy Link"}
              </a>
            </div>
          </div>
        </div>
      )}
    </>
    )
});

export default Player;